import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * URL
 */
export class Url extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 値
   */
  static create(value: string): Url {
    return new Url(value);
  }

  /** デフォルト値 */
  static get defaultValue() {
    return '';
  }

  /** キー */
  static get key(): string {
    return 'url';
  }

  /** タイプ */
  static get type(): string {
    return 'text';
  }

  /** ラベル */
  static get label(): string {
    return 'URL';
  }

  /** プレースホルダー */
  static get placeholder(): string {
    return 'www.example.com';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
    };
  }
}
